/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'device-xl': {
    width: 16,
    height: 16,
    viewBox: '0 2 24 20',
    data: '<path pid="0" d="M21 17H3V5h18m0-2H3a2 2 0 00-2 2v12a2 2 0 002 2h5v2h8v-2h5a2 2 0 002-2V5a2 2 0 00-2-2z"/>'
  }
})
